import * as React from 'react';
import { IgcAvatarComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * An avatar component is used as a representation of a user identity
 * typically in a user profile.
 * @slot  - Renders an icon inside the default slot.
 * @csspart base - The base wrapper of the avatar.
 * @csspart initials - The initials wrapper of the avatar.
 * @csspart image - The image wrapper of the avatar.
 * @csspart icon - The icon wrapper of the avatar.
 * @class
 */
export const IgrAvatar = /* @__PURE__ */ createComponent({
  tagName: 'igc-avatar',
  displayName: 'IgrAvatar',
  elementClass: Component,
  react: React,
});

export type IgrAvatar = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrAvatarModule = Component;
